import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box } from '@chatterbug/aaron'

import ProgressBarVertical from 'src/ui/ProgressBarVertical/ProgressBarVertical'

const StatItemProgress = ({
  progressAchieved,
  progressTotal,
  progressBackgroundColor,
  progressBarColor,
  title,
  label,
  Divider,
}) => {
  return (
    <Flex>
      {Divider && <Divider />}
      <Flex
        alignself="center"
        flexDirection="row"
        // 6px to align text and number with those of statItem
        mt={6}
      >
        <ProgressBarVertical
          completeFraction={(progressAchieved / progressTotal) * 100}
          backgroundColor={progressBackgroundColor}
          barColor={progressBarColor}
          mr="1x"
        />
        <Flex flexDirection="column">
          <Flex alignItems="center" mb={10}>
            <Box as="h4" variant="text.tinyTitle" color="black0">
              {title}
            </Box>
          </Flex>
          <Flex flexDirection="row" alignItems="center" flexWrap="wrap">
            <Flex flexDirection="row" alignItems="flex-end">
              <Box as="h4" variant="text.h4" color={'black0'} mr="1x">
                {progressAchieved}
              </Box>
              <Box as="h5" variant="text.h5" color={'black0'} mr={4}>
                {' / '}
              </Box>
              <Box as="h5" variant="text.h5" color={'black0'} mr={4}>
                {progressTotal}
              </Box>
            </Flex>
            <Box
              mt="4px"
              variant="text.tinyTitle"
              color="gray60"
              sx={{ whiteSpace: 'nowrap' }}
            >
              {label}
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

StatItemProgress.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Divider: PropTypes.func,
  progressAchieved: PropTypes.number.isRequired,
  progressTotal: PropTypes.number.isRequired,
  progressBackgroundColor: PropTypes.string.isRequired,
  progressBarColor: PropTypes.string.isRequired,
}

export default StatItemProgress
